"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefinedStartDateWindow = exports.definedStartDateWindow = void 0;
var engine_1 = require("../../../engine");
var applyDateRangeWindow_1 = require("../applyDateRangeWindow");
var core_1 = require("../core");
var definedStartDateWindow = function (startDate, accessor) {
    return function (table) {
        var _a;
        var endDate = (_a = (0, engine_1.getLatestValue)(table)) === null || _a === void 0 ? void 0 : _a.timestamp;
        if (!endDate) {
            return table;
        }
        var dateRange = { first: startDate, last: endDate };
        return (0, applyDateRangeWindow_1.applyDateRangeWindow)(table, dateRange, accessor);
    };
};
exports.definedStartDateWindow = definedStartDateWindow;
var createDefinedStartDateWindow = function (startDate) {
    return {
        type: core_1.DateWindowTypes.DEFINED_START,
        startDate: startDate,
    };
};
exports.createDefinedStartDateWindow = createDefinedStartDateWindow;
//# sourceMappingURL=definedStartDateWindow.js.map